import { useEffect, useState } from "react";
export function useActiveSection(order, sectionRefs) {
    const [active, setActive] = useState(order[0]);
    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + 100;
            for (let i = order.length - 1; i >= 0; i--) {
                const id = order[i];
                const el = sectionRefs.current[id];
                if (el && el.offsetTop <= scrollPosition) {
                    setActive(id);
                    break;
                }
            }
        };
        window.addEventListener("scroll", handleScroll, { passive: true });
        handleScroll();
        return () => window.removeEventListener("scroll", handleScroll);
    }, [order, sectionRefs]);
    return active;
}
